import { signal } from 'services/SignalsService'

export default class TextLineEntity extends PIXI.Container {
  constructor() {
    super()
    signal.on('STATE:IN:WIN', () => {
      this.renderable = false
    })
    signal.on('STATE:OUT:WIN', () => {
      this.renderable = true
    })
  }
}
